import { post } from "@/utils/axiosInstance";
import { ENDPOINTS } from "../../constants";

const state = {
  data: {
    commissionAmount: 0,
    targetCommissionAmount: 0,
    fundAmount: 0,
    targetFundAmount: 0,
    period: undefined,
    isSuccessStatus: undefined,
  },
};

const actions = {
  getFundCommissionRate({ commit }, args) {
    return new Promise((resolve) => {
      if (args.cusId === undefined) {
        args.cusId = null;
      }
      post(ENDPOINTS.getFundAndCommissionRates, args, {}, args.cusId).then(
        ({ data }) => {
          if (data) {
            commit("setRates", data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
};

const mutations = {
  setRates(existingState, rates) {
    existingState.data = rates;
  },
};

const getters = {
  fundAndCommissionRates() {
    return state.data;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
